import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type SiteEntity } from '@/libs/api'

import { type FetchSitesByDcIdQuery } from '../api'
import { getSitesByDcIdSelectQueryOptions } from '../query-options'

/**
 * Select用のDCに紐づく地点一覧のUseQuery
 */
export const useSitesByDcIdSelectQuery = (
  query: FetchSitesByDcIdQuery,
  options?: {
    disabled: boolean
  }
): UseQueryResult<SiteEntity[]> => {
  const disabled = options?.disabled ?? false
  return useQuery<SiteEntity[]>({
    ...getSitesByDcIdSelectQueryOptions(query),
    enabled: !disabled,
    retry: false
  })
}
